
import { map } from 'lodash';
import { User } from '../user/user';
import { Document } from '../document/document';

const STATUS = {
  'DRAFT': 'Brouillon',
  'PRODUCTION': 'Production',
  'ARCHIVE': 'Archive'
};

export class Revision {
  id: string
  number: string
  status: string
  executions_count: number

  document: Document
  documents: Document[]

  created_at: number
  created_by: User

  updated_at: number
  updated_by: User

  constructor(data: any = {}) {
    Object.assign(this, data);

    if(this.created_by) {
      this.created_by = new User(this.created_by);
    }

    if(this.updated_by) {
      this.updated_by = new User(this.updated_by);
    }

    if(this.document) {
      this.document = new Document(this.document);
    }

    if(this.documents) {
      this.documents = map(this.documents, d => new Document(d));
    }
  }

  get name() {
    if(this.status === 'DRAFT') {
      return `[Brouillon ${this.number}]`;
    }
    else {
      return this.number;
    }
  }

  get fullname() {
    return `rév ${this.name}`;
  }

  get statusString() {
    return STATUS[this.status];
  }
}
